export default __webpack_public_path__ + "static/media/ico_right_arrow_gold.bfd1603d.svg";